import { createFileRoute, redirect } from "@tanstack/react-router";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。ここはタブ既定への redirect のみ。
export const Route = createFileRoute("/_authenticated/admin/organizations/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/organizations/companies" });
  },
});
